import { CalendarX } from "lucide-react";
import { REPORTS } from "@/constants/testIds";

/** Tarjeta de tasa de no-show (turnos completados vs. no-shows) en el periodo. */
export default function NoShowCard({ noShow, testId = REPORTS.noShowCard }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={testId}>
      <div className="flex items-center gap-3 mb-1">
        <div className="w-9 h-9 rounded-full bg-[#F4E1E1] flex items-center justify-center shrink-0">
          <CalendarX className="w-4 h-4 text-[#A34B49]" />
        </div>
        <div>
          <p className="font-serif text-2xl text-foreground">{noShow.rate_pct}%</p>
          <p className="text-xs text-muted-foreground">Tasa de no-show</p>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-3">
        {noShow.no_show_count} de {noShow.total_relevant} {noShow.total_relevant === 1 ? "turno programado" : "turnos programados"} no se presentaron
      </p>
    </div>
  );
}
